<svg xmlns="http://www.w3.org/2000/svg" [ngClass]="'icon ' + iconCls" class="icon" viewBox="0 0 16 16">
	<g transform="translate(0 0)">
		<rect class="icon__path" width="7" height="7" rx="1" />
		<rect class="icon__path" width="7" height="7" rx="1" transform="translate(9)" />
		<rect class="icon__path" width="7" height="7" rx="1" transform="translate(0 9)" />
		<rect class="icon__path" width="7" height="7" rx="1" transform="translate(9 9)" />
	</g>
</svg>
